module.exports = __webpack_public_path__ + "img/auto_match_fields_icon.8a8d3231.svg";